<template>
  <productTemplate :type="productType"></productTemplate>
</template>

<script>
  import productTemplate from '../widget/productTemplate'

  export default {
    name: "introduction",
    components: {
      "productTemplate": productTemplate,
    },
    data() {
      return {
        productType:"frame",
      };
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/commerical/product/frame.vue